export interface IAlertProps {
	text: string;
	header?: string;
	css?: string;
	buttons?: string[];
	buttonsAlignment?: "left" | "center" | "right";
	blockerCss?: string;
}

export enum RealPosition {
	left = "left",
	right = "right",
	top = "top",
	bottom = "bottom",
	center = "center"
}

export interface ITooltipConfig extends IScreenPosition {
	force?: boolean;
	showDelay?: number;
	hideDelay?: number;
}

export interface IPosition {
	left: number;
	top: number;
	pos: RealPosition;
}

export interface IScreenPosition {
	node: HTMLElement | string;
	position?: Position;
	css?: string;
}

export enum Position {
	right = "right",
	bottom = "bottom",
	center = "center"
}

export enum MessageContainerPosition {
	topLeft = "top-left",
	topRight = "top-right",
	bottomLeft = "bottom-left",
	bottomRight = "bottom-right",
}

export interface IMessageProps {
	text?: string;
	html?: string;
	css?: string;
	expire?: number;
	node?: HTMLElement;
	icon?: string;
	position?: MessageContainerPosition;
}

export interface IMessageContainerInfo {
	[MessageContainerPosition.bottomLeft]?: {
		stack: HTMLElement[];
		container: HTMLElement;
	};
	[MessageContainerPosition.bottomRight]?: {
		stack: HTMLElement[];
		container: HTMLElement;
	};
	[MessageContainerPosition.topLeft]?: {
		stack: HTMLElement[];
		container: HTMLElement;
	};
	[MessageContainerPosition.topRight]?: {
		stack: HTMLElement[];
		container: HTMLElement;
	};
}